<template>
  <MainLayout :page-title="pagetitle" customBack @listen-back="goBack">
    <div slot="main-content" class="main-content">
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        class="ruleForm Outsourcing"
        label-width="140px"
      >
        <el-form-item label="种源名称" prop="productName">
          <el-input
            v-model="ruleForm.productName"
            :disabled="isdisabled"
            class="wihe num_input"
            maxlength="30"
            placeholder="请输入"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="所属作物品种" prop="cropId">
          <div :class="{ disabledValue: default_showValue }">
            <originalSelect
              :backDate.sync="ruleForm.cropId"
              :backisShowDate.sync="isShow"
              :default_showValue="default_showValue"
              :disabled="true"
              :loading="loading"
              :optionList="option"
              class="select_width"
              leftLabel="cropName"
              placeholder="请选择所属作物品种"
              rightLabel="cropAliasName"
              searchPlaceholder="搜索作物、禽畜或水产"
              @addNewkind="addOption"
              @backObjData="backObjData"
            >
            </originalSelect>
          </div>
        </el-form-item>
        <el-form-item label="种源审定编号" prop="productCode">
          <el-input
            v-model="ruleForm.productCode"
            class="wihe num_input"
            maxlength="30"
            placeholder="请输入"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="种源生产主体名称" prop="farmName">
          <el-input
            v-model="ruleForm.farmName"
            class="wihe num_input"
            maxlength="30"
            placeholder="请输入"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="种源统一信用代码" prop="uniformCreditCode">
          <el-input
            v-model="ruleForm.uniformCreditCode"
            class="wihe num_input"
            maxlength="18"
            placeholder="请输入"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="种源简介">
          <el-input
            v-model="ruleForm.productIntro"
            :rows="5"
            class="wihe"
            clearable
            maxlength="600"
            placeholder="请输入"
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item label="种源图片">
          <div class="cert_item">
            <div
              v-for="(item, index) in ruleForm.productImages"
              :key="index"
              class="img-list-item"
            >
              <el-image
                :initial-index="addindex"
                :preview-src-list="ruleForm.productImages"
                :src="setImgUrl(item, 100, 100)"
              />
              <i class="el-icon-error" @click="removeImg(addindex)"></i>
            </div>
            <el-upload
              v-if="ruleForm.productImages.length < 5"
              ref="upload"
              v-loading="uploading"
              :action="uploadAction"
              :auto-upload="false"
              :on-change="handleFileChange"
              :show-file-list="false"
              accept=".jpg,.gif,.png,.jpeg,.bmp,.pdf,.GIF,.BMP,.JPG,.JPEG,.PNG"
              class="upload-img"
              list-type="picture-card"
              multiple
              name="files"
            >
              <i class="el-icon-plus"></i>
              <p>上传照片</p>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="规格">
          <div class="unit_box">
            <el-input
              v-model="ruleForm.unit"
              class="wihe num_input"
              placeholder="请输入"
            >
              <template slot="suffix">{{ ruleForm.toStockUnit }}</template>
            </el-input>
            <div v-show="ruleForm.cropId" style="margin: 0 5px">/</div>
            <el-select
              v-show="ruleForm.cropId"
              v-model="packUnitNamevalue"
              placeholder="请选择"
            >
              <el-option
                v-for="item in packUnitNameoptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="购买数量">
          <el-input
            v-model="ruleForm.quantity"
            class="wihe num_input"
            placeholder="请输入"
          >
            <template slot="suffix">{{ ruleForm.toStockUnit }}</template>
          </el-input>
        </el-form-item>
        <el-form-item label="购买时间">
          <el-date-picker
            v-model="ruleForm.buyDate"
            :clearable="false"
            placeholder="选择日期"
            style="
               {
                width: 100%;
                width: 330px;
              }
            "
            type="date"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="购买人">
          <el-input
            v-model="ruleForm.purchaser"
            class="wihe num_input"
            placeholder="请输入"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="外包装图片">
          <div class="cert_item">
            <div
              v-for="(item, index) in ruleForm.images"
              :key="index"
              class="img-list-item"
            >
              <el-image
                :initial-index="addindex_images"
                :preview-src-list="ruleForm.images"
                :src="setImgUrl(item, 100, 100)"
              />
              <i
                class="el-icon-error"
                @click="removeImg(addindex_images, 1)"
              ></i>
            </div>
            <el-upload
              v-if="ruleForm.images.length < 5"
              ref="upload"
              v-loading="uploading_img"
              :action="uploadAction"
              :auto-upload="false"
              :on-change="handleFileChange_images"
              :show-file-list="false"
              accept=".jpg,.gif,.png,.jpeg,.bmp,.pdf,.GIF,.BMP,.JPG,.JPEG,.PNG"
              class="upload-img"
              list-type="picture-card"
              multiple
              name="files"
            >
              <i class="el-icon-plus"></i>
              <p>上传照片</p>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <div class="submit_div">
        <el-button
          :loading="loading"
          type="primary"
          @click="submitForm('ruleForm')"
        >
          保存
        </el-button>
      </div>
    </div>
  </MainLayout>
</template>
<script>
import { snkd } from "@/api/api";
import { v4 as uuidv4 } from "uuid";
import MainLayout from "@/layout/MainLayout";
import { getStorage } from "@/utils/storage";
import { cropService, getById } from "@/api/request/snkd.produce";
import originalSelect from "@/components/originalSelect";
import { upload } from "@/api/request/snkd.foundation";
import { setImgUrl, formatDate } from "@/utils";
import { insertOrUpdate, agriResPackUnit } from "@/api/request/snkd.produce";

export default {
  components: { MainLayout, originalSelect },
  data() {
    var validatePass = (rule, value, callback) => {
      setTimeout(() => {
        if (this.isShow) {
          callback();
        } else {
          if (this.ruleForm.cropId) {
            callback();
          } else {
            callback(new Error("请选择农产品"));
          }
        }
      }, 500);
    };
    return {
      isdisabled: false,
      default_showValue: "",
      pagetitle: "新增种源",
      packUnitNameoptions: [],
      packUnitNamevalue: 1,
      addindex_images: 0,
      addindex: 0,
      ruleForm: {
        cropId: "",
        cropName: "",
        productName: "",
        productCode: "",
        farmName: "",
        uniformCreditCode: "",
        unit: "",
        productIntro: "",
        quantity: "",
        purchaser: "",
        buyDate: "",
        productImages: [], //种源图片
        images: [],
      },
      rules: {
        cropId: [
          { required: true, validator: validatePass, trigger: "change" },
        ],
        productCode: [
          { required: true, message: "请输入种源审定编号", trigger: "change" },
        ],
        productName: [
          { required: true, message: "请输入种源名称", trigger: "change" },
        ],
        farmName: [
          {
            required: true,
            message: "请输入种源生产主体名称",
            trigger: "change",
          },
        ],
        uniformCreditCode: [
          {
            required: true,
            message: "请输入种源统一信用代码",
            trigger: "change",
          },
        ],
      },
      loading: false,
      option: [],
      uploadAction: snkd.foundation.file.upload,
      uploading: false,
      uploading_img: false,
      circulateList: [
        {
          cityId: "",
          cityName: "",
          contac: "",
          contactsTel: "",
          countyId: "",
          countyName: "",
          name: "",
          provinceId: "",
          provinceName: "",
          state: "",
        },
      ],
      // 省数据
      buttonStateList: [],
      info: getStorage("FARMINFO"),
      options: [],
      selectLoading: false,
      fileObj: {},
      pickerDateOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      disabled: false,
      fileLength: 0,
      fileLength_image: 0,
      isShow: false,
    };
  },
  created() {
    const { companyId, farmId } = this.info;
    if (this.$route.query.id) {
      this.isdisabled = true;
      this.pagetitle = "编辑种源";
      this.getByIdEnd();
      this.getlistUnit();
    }
    console.log();
    this.getOption();
    this.ruleForm.farmId = farmId;
    this.ruleForm.companyId = companyId;
  },
  methods: {
    setImgUrl,
    async getByIdEnd() {
      try {
        let res = await getById(this.$route.query.id);
        this.ruleForm = Object.assign(this.ruleForm, res.obj);
        this.ruleForm.buyDate = this.ruleForm.buyDate
          ? formatDate(this.ruleForm.buyDate, "yyyy-MM-dd")
          : "";
        this.ruleForm.productImages = this.ruleForm.productImages
          ? this.ruleForm.productImages.split(",")
          : [];
        this.ruleForm.images = this.ruleForm.images
          ? this.ruleForm.images.split(",")
          : [];
        this.default_showValue = this.ruleForm.cropName;
        this.ruleForm.toStockUnit = this.ruleForm.meterUnitName || "公斤";
        this.packUnitNamevalue = this.ruleForm.packUnitId
          ? this.ruleForm.packUnitId
          : 1;
      } catch (e) {
        console.log(e);
      }
    },
    async getlistUnit() {
      try {
        let res = await agriResPackUnit();
        this.packUnitNameoptions = res.obj;
      } catch (e) {
        console.log(e);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    // 上传发生变化钩子
    async handleFileChange(file) {
      this.andleFileChan(file, 5, this.fileLength);
    },
    async handleFileChange_images(file) {
      this.andleFileChan(file, 5, this.fileLength_image, 1);
    },
    async andleFileChan(file, limit, fileLength, type) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("图片上传大小不超过10MB");
        return false;
      }
      if (fileLength >= limit) {
        this.$message.info("图片最多上传9张");
        return false;
      }
      fileLength = fileLength + 1;
      await this.submitFileForm(file, type);
    },
    // 提交上传文件
    async submitFileForm(file, limit) {
      let formData = new FormData();
      const dir = "snkoudai/web/";
      const fileType = file.raw["type"];
      const index = fileType.lastIndexOf("/") + 1;
      const fileFormat = fileType.substring(index, fileType.length);
      var fileName = `${uuidv4()}.${fileFormat}`;
      formData.append("file", file.raw);
      formData.append("folderPath", dir);
      formData.append("originalFilename", fileName);

      if (limit == 1) {
        this.uploading_img = true;
      } else {
        this.uploading = true;
      }
      await upload(formData)
        .then((res) => {
          const uploadRet = res && res.obj && res.obj.internetUrl;
          if (!uploadRet) return;
          if (limit == 1) {
            this.ruleForm.images.push(res.obj.internetUrl);
          } else {
            this.ruleForm.productImages.push(res.obj.internetUrl);
          }

          if (limit == 1) {
            this.uploading_img = false;
          } else {
            this.uploading = false;
          }
        })
        .catch(() => {
          this.$message.error("上传失败！");
          if (limit == 1) {
            this.uploading_img = false;
          } else {
            this.uploading = false;
          }
        });
    },
    backState(parems) {
      const { i, state, allState } = parems;
      this.buttonStateList[i] = { state, allState, i };
    },
    removeList(i) {
      this.circulateList.splice(i, 1);
      this.buttonStateList.splice(i, 1);
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true;
            const body = {
              ...this.ruleForm,
            };
            body.productImages = body.productImages
              ? body.productImages.join(",")
              : "";
            body.images = body.images ? body.images.join(",") : "";
            if (this.ruleForm.unit) {
              body.meterUnitId = 3;
              body.meterUnitName = this.ruleForm.toStockUnit;
              body.packUnitId = this.packUnitNamevalue;
              body.packUnitName = this.packUnitNameoptions.filter(
                (itmer) => body.packUnitId == itmer.id
              )[0].name;
            }
            const { respCode } = await insertOrUpdate(body);
            if (!respCode) {
              this.$message({
                type: "info",
                message: "提交成功",
              });
              setTimeout(() => {
                this.goBack();
              }, 1000);
            }
          } catch (error) {
            console.log(error);
          } finally {
            this.loading = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async addOption(val, backFun) {
      try {
        const { companyId, farmId } = this.info;
        await cropService.addFeedback({
          companyId,
          farmId,
          cropName: val,
        });
        backFun(true);
      } catch (error) {
        backFun(false);
      } finally {
        this.getOption();
      }
    },
    async getOption() {
      const { companyId } = this.info;
      this.loading = true;
      try {
        const { list } = await cropService.listAllShort({ companyId });
        this.option = list;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    backObjData(params) {
      if (!params) return;
      const { cropName, cropSubjectIdentifier } = params;
      // cropCategoryUnit
      this.ruleForm.cropName = cropName;
      this.ruleForm.subjectIdentifier = cropSubjectIdentifier;
      if (
        cropSubjectIdentifier === "agri" ||
        cropSubjectIdentifier === "fishery"
      ) {
        this.ruleForm.toStockUnit = "公斤";
      } else {
        //先写死公斤
        this.ruleForm.toStockUnit = "公斤";
      }
      // this.ruleForm.productName = "";
      this.getlistUnit();
      this.$refs.ruleForm.validateField("cropId");
    },
    removeImg(i, imts) {
      if (imts) {
        this.ruleForm.images.splice(i, 1);
        this.fileLength_image = this.fileLength - 1;
        return;
      }
      this.ruleForm.productImages.splice(i, 1);
      this.fileLength = this.fileLength - 1;
    },
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  width: 1200px;
  min-height: calc(100vh - 120px);
  background: #ffffff;
  margin: 0 auto;
  padding: 30px 10px 10px;
}

.Outsourcing {
  padding: 56px 55px 0;
  align-items: center;
  flex-direction: column;
  display: flex;

  ::v-deep .el-form-item {
    margin-bottom: 40px !important;
  }
}

.ruleForm .el-form-item {
  width: 50%;
  margin-right: 0px;
}

.wihe {
  width: 410px;
}

.circulate_div {
  border-top: 1px solid #e4e4e4;
  padding: 25px 40px 0;
}

.circulate_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.submit_div {
  width: 100%;
  text-align: center;
}

.img-list-item {
  width: 100px;
  height: 100px;
  margin-right: 20px;
  margin-bottom: 20px;
  position: relative;

  i {
    position: absolute;
    right: -15px;
    top: 0;
  }

  .el-image {
    width: 100%;
    height: 100%;
  }
}

::v-deep .el-input-group__append {
  background-color: #fff;
}

.select_width {
  width: 410px;
  display: block;
}

.cert_item {
  //width: 360px;
  display: flex;
  flex-wrap: wrap;
}

.i_text {
  display: block;
  font-size: 12px;
}

.upload-img {
  position: relative;
  width: 100px;
  height: 100px;

  p {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 20px;
    text-align: center;
    color: #ccc;
    font-size: 12px;
    box-sizing: border-box;
    padding-top: 0;
  }

  i {
    color: #dcdfe6;
    position: absolute;
    font-size: 20px;
    left: 40px;
    top: 30px;
  }

  ::v-deep .el-upload--picture-card {
    width: 100%;
    height: 100%;
  }
}

.autocomplete {
  width: 300px;
}

.addr {
  color: #ccc;
  font-size: 12px;
}

.submit_div {
  ::v-deep .el-button--primary {
    width: 140px;
  }
}

.unit_box {
  display: flex;
}
</style>

<style lang="scss">
.el-select-dropdown__item {
  height: auto;
}

.el-message-box__title {
  span {
    font-weight: bold;
  }
}

.disabledValue .el-popover__reference {
  background: #f5f7fa;
}
</style>
